import React from 'react';
import { useTitle } from "fearless-common-ui";
import {concepts, User, LoggedUIEvent} from 'fearless-common';
import {ColumnDef} from "@tanstack/react-table";
import {adminRoutes} from "../../utils/routes";
import Pages from "../../components/layout/Pages";
import OrderableTable from "../../components/layout/OrderableTable";
import {backendEndpoints} from "../../libs/backendEndpoints";
import Description from "../../components/Description";
import useGet from "../../components/hooks/useGet";
import CellRender from "../../components/layout/table/CellRender";

const columns: ColumnDef<LoggedUIEvent>[] = [
  { id: 'user_id', accessorKey: 'user_id', header: 'ID', enableSorting: false },
  { id: 'tag', accessorKey: 'tag', header: 'Tag', enableSorting: false },
  { id: 'created_at', accessorKey: 'created_at', header: 'Date time', cell: CellRender.DateTime, enableSorting: false },
];

/**
 * Admin page listing all logged UI events with user filtering.
 */
export default function AdminLoggedUIEvents() {
  useTitle(`Admin ${concepts.LoggedUIEvents}`);
  const { data: users } = useGet<User[]>({
    endpoint: adminRoutes.adminFiltersUser
  });
  return (
    <Pages.Centred padded>
      <div className="d-inline-flex align-items-center gap-4">
        <h1>{concepts.LoggedUIEvents}</h1>
      </div>
      <Description className="neutral-500">
        Logged UI events are registered events from
      </Description>
      <OrderableTable<LoggedUIEvent>
        filterables={[
          {
            field_name: 'user_id',
            label: 'User',
            options: (users || []).map((u) => ({ value: u.id.toString(), label: `${u.first_name} ${u.last_name} - ID ${u.id}`}))
          },
        ]}
        baseEndpoint={backendEndpoints.getLoggedUiEvents}
        memoisedColumns={columns}
      />
    </Pages.Centred>
  );
}
